(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/valentines2025/valentines.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/valentines2025/valentines.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const valentines2025Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/valentines2025");
const BottomFrame = () => React.createElement("div", {
  className: "valentines-bottom-frame-2025 row pointer-none"
}, React.createElement("div", {
  className: "valentines-bottom-layers-2025 relative col-md-12 u-flex u-flex-justify-content-center"
}, React.createElement("img", {
  alt: "alla hj\xE4rtans dag-ram",
  src: "".concat(valentines2025Path, "/ahd-ram.png")
})));
const TopFrame = () => React.createElement("div", {
  className: "valentines-top-frame-2025 row"
}, React.createElement("div", {
  className: "valentines-top-frame-container-2025 relative col-md-12"
}));
const Valentines = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.valentines2025.Valentines', Valentines);

 })(window);